'use strict';

module.exports = paragraph;
var all = require('../all');
function paragraph(h, node) {
  return h(node, 'p', all(h, node));
}